import React, { useContext, useEffect, useState } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, VerticalLineIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon } from "../../svg/svgIcons";
import UtilContext from '../../../components/UtilContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { uiT as t } from '../../../utils/uiTranslate';

export default function TrainingCompanyCertificateAdd({training_company, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { openFavoriteDialog, toast, setFastView } = useContext(UtilContext);
    const [formType, setFormType] = useState(type);

    const [companyValidity, setCompanyValidity] = useState(() => training_company?.validity == 1 || training_company?.validity === '1' ? 1 : 0);
    const [savingValidity, setSavingValidity] = useState(false);
    useEffect(() => {
        setCompanyValidity(training_company?.validity == 1 || training_company?.validity === '1' ? 1 : 0);
    }, [training_company?.id, training_company?.validity]);

    const handleSaveCompanyValidity = (closeAfter = false) => {
        if (training_company?.id == null) return;
        setSavingValidity(true);
        const formData = new FormData();
        formData.append('validity', String(companyValidity));
        postRequest('/api/companies/update/' + training_company.id, formData, true)
            .then(() => {
                getRequest('/api/companies').then((r) => {
                    if (r?.data != null) dispatch({ type: 'load_companies', newCompanies: r.data });
                });
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('TrainingCompanyCertificateAdd.Text.Stav_skoliacej_firmy_bol_ulozeny') });
                if (closeAfter) dispatch({ type: 'close_tab', id: state.selectedTab });
            })
            .catch(() => alert(t('Common.Toast.SaveFailedAlert')))
            .finally(() => setSavingValidity(false));
    };


    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={savingValidity} onClick={() => handleSaveCompanyValidity(true)}><SaveAndCloseIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={savingValidity} onClick={() => handleSaveCompanyValidity()}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button onClick={() => openFavoriteDialog(t('TrainingCompanyCertificateList.Text.Karta_skoliacej_firmy'),"TrainingCompanyCertificateAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("TrainingCompanyCertificateAdd", {}, [])}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          </IntersectionObserverWrapper>
        </div>
        <div className="w-full relative flex flex-col min-h-[calc(100vh_-_177px)] overflow-x overflow-y-auto px-4 py-4">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.KARTA_SKOLIACEJ_FIRMY')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {training_company?.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.CompanyNameUpper')}</label>
                        <input
                        readOnly={true}
                            name='name'
                            type="text"
                            value={training_company.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="tel_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.PhoneNumber')}</label>
                        <input
                        readOnly={true}
                            name='tel_number'
                            type="text"
                            value={training_company?.tel_number}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    
                      <div>
                        <label
                            htmlFor="email"
                            className="block text-md font-semibold text-gray-800"
                        >
                            E-MAIL
                        </label>
                        <input
                        readOnly={true}
                            name='email'
                            type="text"
                            value={training_company?.email}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="contact_person"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >{t('Common.ContactPersonUpper')}</label>
                        <input
                        readOnly={true}
                            name='contact_person'
                            type="text"
                            value={training_company?.contact_person}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='address'
                            type="text"
                            value={training_company?.address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fax"
                            className="block text-md font-semibold text-gray-800"
                        >
                             FAX
                        </label>
                        <input
                        readOnly={true}
                            name='fax'
                            type="text"
                            value={training_company?.fax}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="web_address"
                            className="block text-md font-semibold text-gray-800"
                        >
                            WEB. ADRESA
                        </label>
                        <input
                        readOnly={true}
                            name='web_address'
                            type="text"
                            value={training_company?.web_address}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.NoteUpper')}</label>
                        <textarea
                        readOnly={true}
                            name='gauge_name'
                            type="text"
                            value={training_company?.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-gray-200 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
                        <div className="mt-4 pt-4 border-t border-gray-300">
                            <h3 className="text-md font-semibold text-gray-800 mb-3">{t('Common.TrainingCompanyStatus')}</h3>
                            <div className="mb-3">
                                <label className="block text-sm font-semibold text-gray-700 mb-1">{t('Common.Status')}</label>
                                <select
                                    value={companyValidity === 1 || companyValidity === '1' ? '1' : '0'}
                                    onChange={(e) => setCompanyValidity(e.target.value === '1' ? 1 : 0)}
                                    className="block w-full px-3 py-2 text-gray-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring"
                                >
                                    <option value="1">{t('Common.Active')}</option>
                                    <option value="0">{t('QualityPartnerList.Status.Excluded')}</option>
                                </select>
                            </div>
                        </div>
            </div> 
            </div>
        </div>
        </div>
            </> 
            );
} 
